import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { AdminService } from "./services/admin/admin.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd, ActivatedRoute, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
// import { faArrowLeft, faListCheck, faUtensils, faBowlRice, faLanguage, faGear, faFileInvoice, faBars, faChartPie } from '@fortawesome/free-solid-svg-icons'
import { LanguagesService } from './services/languages/languages.service';
import { ThemeService } from './services/theme/theme.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileComponent } from './components/pages/setting/profile/profile.component';
import { CommonModule } from '@angular/common';
import { NgxPullToRefreshModule } from 'ngx-pull-to-refresh';
import { SeandComponent } from "./components/pages/auth/verify/seand/seand.component";
import { NavigacionComponent } from './components/layout/navigacion/navigacion.component'
import { MatIconModule } from '@angular/material/icon';

import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ProfileComponent,
    SeandComponent,
    NavigacionComponent,
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    NgxPullToRefreshModule,
    TranslateModule,
    MatIconModule,
    SidebarComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isOpen = true;
  showSidebar: boolean = true;
  id: number | null = null;

  isSystemDark: boolean = false;

  targetElement: Element;


  selectedLanguage: any;

  isRefreshing = false;
  email: string

  isPricingPage = false;

  showProfileModal = false;

  @ViewChild('verifyModal') verifyModal: any;

  @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;

  ngAfterViewInit() {
    this.targetElement = this.scrollContainer?.nativeElement || document.querySelector('html');
  }


  constructor(
    public admin: AdminService,
    private translate: TranslateService,
    private languageService: LanguagesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public ThemeService: ThemeService,
    private modalService: NgbModal,

  ) {
    // admin.refreshToken().subscribe(
    //   (res: any) => {
    //     console.log(res)
    //   },
    //   (error: any) => {
    //     console.log(error)
    //   }
    // )
    this.activatedRoute.queryParamMap.subscribe((params) => {
      const checkVerify = params.get('checkverify');
      
      if (checkVerify) {
  
        if (this.admin.isAdmin()) {
          this.admin.getMyInfo().subscribe((res: any) => {
            if (res?.email_verify == 0) {
              this.email = res?.email;
              this.showModal();
            }
          });
        }
      }
    });
  }

  ngOnInit() {
    this.targetElement = document.querySelector('html');
    // this.initializeLanguage();
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.translate.use(language.code); // შეცვალეთ თარგმანი
    });


    
    

    this.handleSidebarOnScreenResize();
    this.subscribeToRouterEvents();

    // სისტემური თემა
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    this.isSystemDark = prefersDark.matches;

    // ამ ცვლილებების შესაფერისი განსაზღვრა
    prefersDark.addEventListener('change', (event) => {
      this.isSystemDark = event.matches;
    });
  }

  showModal() {
    this.modalService.open(this.verifyModal, { });
  }


  myRefreshEvent(event: Subject<any>, message: string) {
    if (!this.isRefreshing) { // დაამატეთ ბულეანი, რათა ციკლური რეფრეში თავიდან აიცილოთ
      this.isRefreshing = true;
      setTimeout(() => {
        event.next(undefined);
        this.isRefreshing = false;
      }, 3000);
    }
  }

 
  // Subscribe to router events to get nested route parameters and handle sidebar visibility
  subscribeToRouterEvents(): void {
  const updateLayout = (): void => {
    const cleanUrl = this.router.url.split('?')[0];
    this.isPricingPage = cleanUrl === '/pricing';
    const fullPageRoutes = [
      '/signin',
      '/signup',
      '/pricing',
      '/pey/fail',
      '/pey/success',
      '/reset/password',
      '/new/password',
      '/verify',
      '/rules',
      '/not-found',
    ];

    this.showSidebar = cleanUrl.startsWith('/app/');
  };

  updateLayout();

  this.router.events
    .pipe(
      filter(
        (event): event is NavigationEnd =>
          event instanceof NavigationEnd
      ),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }

        return route;
      }),
      mergeMap((route) => route.params)
    )
    .subscribe((params) => {
      this.id = params['id']
        ? Number(params['id'])
        : null;

      updateLayout();
    });
}

  // Close sidebar if screen is small (<= 768px)
  handleSidebarOnScreenResize() {
    if (window.innerWidth <= 768) {
      this.isOpen = false;
    }
  }

  // Toggle navigation (menu)
  toggleNav(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  menuItemClicked() {
    if (window.innerWidth <= 768) {
      this.isOpen = false;
    }
  }

  closeSidebar(event: Event) {
    if (window.innerWidth <= 768 && this.isOpen) {
      this.isOpen = false;
      event.stopPropagation();
    }
  }

  // HostListener to dynamically handle window resize events
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 768) {
      this.isOpen = true; // Open sidebar for larger screens
    } else {
      this.isOpen = false; // Close sidebar for smaller screens
    }
  }

  
}